<template>
  <footer class="app-footer">
  	<div>© 2021 Xpressbees.</div>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?72f9e4f7